import React from "react";
import PageHero from "@/components/PageHero";
import ServiceAreasStrip from "@/components/ServiceAreasStrip";
import QuoteCTA from "@/components/QuoteCTA";

export default function ServiceAreas() {
  return (
    <div data-testid="service-areas-page">
      <PageHero
        eyebrow="Service Areas"
        title="Northern Utah."
        italic="Southern Idaho."
        description="If your zip code isn't listed, ask anyway — we cover more ground than the map lets on."
        testId="service-areas-hero"
      />
      <ServiceAreasStrip />
      <QuoteCTA />
    </div>
  );
}
